import { render, staticRenderFns } from "./DetailJenisBarang.vue?vue&type=template&id=f4d0ebc0&"
import script from "./DetailJenisBarang.vue?vue&type=script&lang=js&"
export * from "./DetailJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports